export const JOB_TYPES = {
  composite: 1,
  mechanical: 2,
};
